import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { globals } from '../globals';
import ContactSheet from './ContactSheet';
import ContactSheetFolders from './ContactSheetFolders';
import './IptcSearch.css';
import { useUser } from '../context/UserContext';
import { useLocation } from 'react-router-dom';

function IptcSearch() {
  const [query, setQuery] = useState('');
  const [searchMode, setSearchMode] = useState('images'); // "images" | "folders"
  const [photos, setPhotos] = useState([]);
  const [folders, setFolders] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { user } = useUser();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const queryFromUrl = params.get('query') || '';
  const showSearchBar = params.get('showSearchBar') !== 'false';
  const rawMode = params.get('searchMode');
  const modeFromUrl = rawMode === 'images' ? 'images' : 'folders'; // default: cartelle

  const handleSearch = useCallback(async (customQuery = query, mode = searchMode) => {
    if (!customQuery) return;
    setLoading(true);
    setError('');
    setPhotos([]);
    setFolders([]);

    try {
      const action = mode === 'folders' ? 'searchFolders' : 'searchImages';
      const res = await axios.get(`${globals.homepageUrl}/php/iptcsearch.php?action=${action}&search=${encodeURIComponent(customQuery)}`);

      if (res.data.success) {
        setTotal(res.data.total || 0);

        if (mode === 'images') {
          setPhotos(res.data.images.map((image) => ({
            src: globals.homepageUrl + image.src,
            alt: image.caption || '',
            width: image.width || 800,
            height: image.height || 600,
            fullwidth: image.fullwidth,
            fullheight: image.fullheight,
            description: image.caption || '',
            date: image.date,
          })));
        } else {
          setFolders(res.data.folders || []);
        }
      } else {
        setError('Errore nella ricerca');
      }
    } catch (err) {
      setError('Errore di rete o server');
    } finally {
      setLoading(false);
    }
  }, [query, searchMode]);

useEffect(() => {
  if (queryFromUrl) {
    setSearchMode(modeFromUrl);
    setQuery(queryFromUrl);
    handleSearch(queryFromUrl, modeFromUrl);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [queryFromUrl, modeFromUrl]);

  const handleSaveSearch = async () => {
    const imagePaths = photos.map((photo) => photo.src.replace(globals.homepageUrl, ''));
    try {
      const res = await axios.post(`${globals.homepageUrl}/php/iptcsearch.php`, {
        save: true,
        search: query,
        images: imagePaths,
        featured: imagePaths[0] || null
      });

      if (res.data.success) {
        alert('Ricerca salvata con successo!');
      } else {
        alert('Errore nel salvataggio');
      }
    } catch (err) {
      alert('Errore di rete');
    }
  };

  return (
    <div className="iptc-search-container">
      {showSearchBar && (
        <>
          <h2 style={{ fontSize: '17px', margin: '2px' }}>Cerca tra i metadati IPTC</h2>
          <div className="search-bar">
            <input
              type="text"
              placeholder="es. spal AND primavera..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />

            <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', gap: '0px' }}>
              <div style={{ display: 'flex', width: '10%' }}>
                <input
                  type="radio"
                  value="images"
                  checked={searchMode === 'images'}
                  onChange={(e) => setSearchMode(e.target.value)}
                  style={{ marginRight: '10px' }}
                />
                <label>Immagini</label>
              </div>

              <div style={{ display: 'flex', width: '10%' }}>
                <input
                  type="radio"
                  value="folders"
                  checked={searchMode === 'folders'}
                  onChange={(e) => setSearchMode(e.target.value)}
                  style={{ marginRight: '10px' }}
                />
                <label>Cartelle</label>
              </div>
            </div>

            <button onClick={() => handleSearch()}>Cerca</button>
            {user?.role === 'administrator' && searchMode === 'images' && (
              <button onClick={handleSaveSearch} style={{ backgroundColor: 'rgba(255,0,0,0.5)' }}>
                Salva questa ricerca
              </button>
            )}
          </div>
        </>
      )}

      {loading && <p>Caricamento...</p>}
      {error && <p className="error">{error}</p>}

      {searchMode === 'images' && photos.length > 0 && (
        <>
          <p>{total} immagini trovate</p>
          <ContactSheet photos={photos} />
        </>
      )}

      {searchMode === 'folders' && folders.length > 0 && (
        <>
          <p>{total} cartelle trovate</p>
          <ContactSheetFolders folders={folders} />
        </>
      )}
    </div>
  );
}

export default IptcSearch;
